import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { BRAND_CONFIG } from '@/config/brand';
import { HeroConfetti } from '../landing/HeroConfetti';
import { HeroPhoneShowcase } from '../landing/HeroPhoneShowcase';

interface AuthShellProps {
  children: React.ReactNode;
}

export const AuthShell: React.FC<AuthShellProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col lg:grid lg:grid-cols-[5fr_7fr] bg-gradient-to-br from-pink-50 via-rose-50 to-amber-50">
      <aside className="relative overflow-hidden flex flex-col items-center px-6 py-6 lg:py-12">
        <HeroConfetti />
        <div className="relative z-10 flex flex-col items-center text-center gap-6 lg:gap-8">
          <Link to="/" className="flex items-center gap-2">
            <img src={BRAND_CONFIG.logo} alt={BRAND_CONFIG.logoAlt} className="h-10 w-10" />
            <span className="text-xl font-bold text-wedding-text-title whitespace-nowrap">{BRAND_CONFIG.name}</span>
          </Link>
          <div className="hidden lg:block">
            <HeroPhoneShowcase className="w-[240px]" />
          </div>
          <div className="hidden lg:flex items-center gap-6 text-sm text-wedding-text-body">
            <span className="flex items-center gap-1.5">
              <Check className="h-4 w-4 text-wedding-pink" />
              免費版不用綁卡
            </span>
            <span className="flex items-center gap-1.5">
              <Check className="h-4 w-4 text-wedding-pink" />
              5 分鐘完成
            </span>
          </div>
        </div>
      </aside>
      <main className="flex-1 flex items-center justify-center px-4 pb-10 lg:py-12">
        {children}
      </main>
    </div>
  );
};
